import isEmpty from 'lodash/isEmpty';
import { takeEvery, put, fork, all, call, select } from 'redux-saga/effects';
import { cloneDeep } from 'lodash';

import * as api from '../../services/record/apiRecord';
import {
  fetchCSVExportForEdit,
  previewSearchRecord,
} from '../../services/csv_export/api_csv_export';

import * as SagaType from '../../constants/constant_saga_types';

import Handlebars from '../../utils/handlebar';
import { getErrorMessage } from '../../utils';
import { getCompareDateRange } from '../../components/admin/dashboard/common/date.helper';

export default function* (ksApp) {
  return yield all([
    fork(fetchRecordTypes, ksApp),
    fork(fetchRecordFields, ksApp),
    fork(fetchRecordPreview, ksApp),
    fork(fetchRecordField, ksApp),
  ]);
}

export function* fetchRecordTypes(feathersApp) {
  yield takeEvery(
    SagaType.FETCH_RECORD_TYPES,
    callFetchRecordTypes,
    feathersApp,
  );
}
function* callFetchRecordTypes(feathersApp, action) {
  try {
    const { context } = action;

    const records = yield call(api.fetchRecordTypes, feathersApp, context);
    yield put({
      type: SagaType.DONE_FETCH_RECORD_TYPES,
      payload: { records, context },
    });
  } catch (err) {
    console.error('[ ERROR ][ SAGA_RECORD ] : callFetchRecordTypes', err);
  }
}

export function* fetchRecordFields(feathersApp) {
  yield takeEvery(
    SagaType.FETCH_RECORD_FIELDS,
    callFetchRecordFields,
    feathersApp,
  );
}
function* callFetchRecordFields(feathersApp, action) {
  try {
    yield put({ type: SagaType.FETCHING_RECORD_FIELDS });
    const { context } = action;

    if (isEmpty(context)) throw new Error('Context is not defined.');

    const fields = yield call(api.getRecordFields, feathersApp, context);
    yield put({
      type: SagaType.DONE_FETCH_RECORD_FIELDS,
      payload: { ...fields, context },
    });
  } catch (err) {
    console.error('[ ERROR ][ SAGA_RECORD ] : fetchRecordFields', err);
  }
}

export function* fetchRecordField(feathersApp) {
  yield takeEvery(
    SagaType.FETCH_RECORD_FIELD,
    callFetchRecordField,
    feathersApp,
  );
}
function* callFetchRecordField(feathersApp, action) {
  try {
    yield put({ type: SagaType.FETCHING_RECORD_FIELD });
    const { payload } = action;
    const { context, field } = payload || {};

    if (isEmpty(context)) throw new Error('Context is not defined.');
    if (isEmpty(field)) throw new Error('Field is not defined.');

    const fieldDef = yield call(api.getRecordField, feathersApp, payload);

    if (!fieldDef) throw new Error('Field is does not exists');

    yield put({
      type: SagaType.DONE_FETCH_RECORD_FIELD,
      payload: fieldDef,
    });
  } catch (err) {
    yield put({
      type: SagaType.ERROR_FETCH_RECORD_FIELD,
      payload: getErrorMessage(err),
    });

    console.error('[ ERROR ][ SAGA_RECORD ] : fetchRecordField', err);
  }
}

export function* fetchRecordPreview(feathersApp) {
  yield takeEvery(
    SagaType.FETCH_RECORD_PREVIEW,
    callFetchRecordPreview,
    feathersApp,
  );
}
function* callFetchRecordPreview(feathersApp, action) {
  const { payload } = action;
  const { limit, offset, id, form } = payload;

  yield put({
    type: SagaType.FETCHING_RECORD_PREVIEW,
    payload: { ...payload, isLoading: true },
  });

  let parsedForm;
  let pristine = payload.pristine;

  if (isEmpty(form)) {
    pristine = true;
    parsedForm = yield call(fetchCSVExportForEdit, feathersApp, { id });
  } else {
    parsedForm = cloneDeep(form);
  }

  parsedForm.compare_filters = yield call(parseSearchRecordCompareFilters, parsedForm.compare_filters);
  parsedForm.filters = yield call(parseSearchRecordFilters, parsedForm.filters);

  const {
    compare_filters,
    fields,
    filters,
    having_query,
    query,
    record_type,
    sorting,
  } = parsedForm;

  try {
    const data = yield call(previewSearchRecord, feathersApp, {
      compare_filters,
      fields,
      filters,
      having_query,
      limit,
      offset,
      query,
      record_type,
      sorting,
    });

    yield put({
      type: SagaType.DONE_FETCH_RECORD_PREVIEW,
      payload: {
        ...payload,
        ...data,
        pristine,
        form: parsedForm,
      },
    });
  } catch (err) {
    console.error('@saga_record::callFetchRecordPreview::error', err);

    yield put({
      type: SagaType.FETCH_RECORD_PREVIEW_ERROR,
      payload: {
        ...payload,
        form: parsedForm,
        error: getErrorMessage(err),
      },
    });
  }
}

export function* parseTemplateFilters(filters) {
  const { user, subsidiary } = yield select();
  const templateData = { user, subsidiary };

  const newFilters = filters.map((filter) => {
    const { value, template, multiple, docType, show } = filter;

    if (!template || (show && value)) return filter;

    const subjectTemplate = Handlebars.compile(template);
    let templateValue = subjectTemplate(templateData);

    if (!templateValue) return filter;

    if (multiple && docType) {
      templateValue = templateValue.split(',');
    }

    const newFilter = {
      ...filter,
      value: templateValue,
    };

    return newFilter;
  });

  return newFilters;
}

export function* parseSearchRecordCompareFilters(compareFilters) {
  if (!compareFilters) return compareFilters;

  const { intl } = yield select();
  const { compare_period, date_ranges } = compareFilters;

  if (compare_period !== 'custom_date:custom_date') {
    const newCompareDateRanges = getCompareDateRange(
      compare_period,
      date_ranges,
      intl,
    );

    compareFilters.date_ranges = newCompareDateRanges;
  }

  return compareFilters;
}

export function* parseSearchRecordFilters(filters) {
  const haveTemplateValue = filters.some(({ template }) =>
    Boolean(template)
  );

  if (haveTemplateValue) {
    return yield call(parseTemplateFilters, filters);
  }

  return filters;
}